import React, { useState } from "react";

import { Button, Confirm, useNotify, useRedirect } from "react-admin";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { doUpdateReloadYardAccount, sendEmails } from "./customerUtils";
import { emailDeleteHTML } from "./emailDeleteHTML";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({ record, className, ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const isDeleteDisabled = () => {
    return loading;
  };

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setLoading(true);
    try {
      debugger;
      // Update customer active = "false", tirggers lambda function "/processCustomer"
      // Only one reloadYardAccount / customer / reloadYard
      let reloadYardAccount = record?.reloadYardAccounts?.items[0];
      reloadYardAccount.active = "false";
      delete reloadYardAccount.createdAt;
      delete reloadYardAccount.updatedAt;

      await doUpdateReloadYardAccount(reloadYardAccount);

      // send silently don't await
      sendEmails(
        {
          email: window.appUser.email,
          firstName: window.appUser.firstName,
          lastName: window.appUser.lastName,
          reloadYardName: window.appUser.reloadYard.name,
        },
        emailDeleteHTML,
      );

      notify("User deleted successfully", "success");
      redirect("/customers");
    } catch (error) {
      logError(
        "managerApp:customers:DeepDeleteButton:handleDelete",
        error,
        notify,
      );
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={isDeleteDisabled()}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={"Delete Confirmation"}
        content={"Are you sure you want to delete this User?"}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
